import script from "./IntellectualConceptsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IntellectualConceptsTab.vue?vue&type=script&setup=true&lang=js"

import "./IntellectualConceptsTab.vue?vue&type=style&index=0&id=5e237c34&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e237c34"]])

export default __exports__